export default __webpack_public_path__ + "static/media/fillPatternSemiLeft.2eaab539.svg";